import styled from 'styled-components';
import { Button } from '@/components/UI/Button/Button';
import { FiltersIcon } from '@/components/UI/Icons/Icons';

export const FiltersButton = styled(Button).attrs({
  appearance: 'primaryOutlined',
  shape: 'square',
  height: 44,
  borderRadius: 14,
})``;

export const FiltersButtonIcon = styled(FiltersIcon).attrs(({ theme }) => ({
  fill: theme.palette.brand.main,
}))``;
